import { Container, Typography, List, ListItem, ListItemText, Box } from '@mui/material';
import HomeNavbar from '../components/home-nav-bar';
import Footer from '../components/footer';

function TermsAndConditions() {
  return (
    <Box>
        <HomeNavbar/>

        <Container maxWidth="md" sx={{ py: 4 }}>
            <Typography variant="h4" component="h1" gutterBottom>
                Terms and Conditions
            </Typography>
            <Typography paragraph>
                The West African Journal of Life Sciences is committed to publishing high-quality articles that contribute to the dissemination of research findings and the advancement of knowledge. We adhere to the following principles:
            </Typography>
            <List>
                <ListItem>
                <ListItemText primary="The journal publishes research manuscripts, short communications, technical reports, review articles, and case studies." />
                </ListItem>
                <ListItem>
                <ListItemText primary="All manuscripts submitted to the West African Journal of Life Sciences must be original and must not have been submitted to or considered by another journal." />
                </ListItem>
                <ListItem>
                <ListItemText 
                    primary={
                        <>
                        Submitted manuscripts undergo a plagiarism check using  {' '}
                        <a href="https://www.duplichecker.com/" target="_blank" rel="noopener noreferrer">
                            Duplichecker
                        </a>. Only manuscripts with a plagiarism status of <b>15% or lower</b> will be sent out for peer review.
                        </>
                    }
                />

                </ListItem>
                <ListItem>
                <ListItemText primary="Manuscripts cannot be withdrawn after the peer review process has commenced. Authors wishing to withdraw their manuscripts at this stage will be required to pay 50% of the publication charges." />
                </ListItem>
                <ListItem>
                <ListItemText primary="Authors must respond to feedback from peer reviewers promptly and comprehensively before proceeding to the final check and publication stage." />
                </ListItem>
            </List>
        </Container>
        <Footer/>
    </Box>
  );
}

export default TermsAndConditions;
